import type { ReactElement } from 'react';
import { weekAndMonthDay } from 'utils/dateTimes';
import UpcomingMenu, { ArrivingStatus } from 'models/UpcomingMenu';

import { Component as ArrivingIcon } from 'icons/icon-circle--arriving.svg';
import { Component as ScheduledIcon } from 'icons/icon-circle--shipping.svg';
import { Component as SkippedIcon } from 'icons/icon-circle--skipped.svg';
import { Component as CancelledIcon } from 'icons/icon-circle--error.svg';
import { Component as QuestionIcon } from 'icons/icon-circle--question.svg';

import PlanName from './PlanName';
import SkipLabel from './SkipLabel';

type Props = { item: UpcomingMenu; };

const STATUS_ICONS = {
  [ArrivingStatus.ARRIVING]: ArrivingIcon,
  [ArrivingStatus.SCHEDULED]: ScheduledIcon,
  [ArrivingStatus.SKIPPED]: SkippedIcon,
  [ArrivingStatus.ADMIN_ORDER_CANCELLED]: SkippedIcon,
  [ArrivingStatus.CANCELLED]: CancelledIcon,
  [ArrivingStatus.PAUSED]: CancelledIcon,
  [ArrivingStatus.RETURNING]: CancelledIcon,
  [ArrivingStatus.SUSPENDED]: CancelledIcon,
};

const STATUS_NAMES = {
  [ArrivingStatus.ARRIVING]: 'ARRIVING',
  [ArrivingStatus.SCHEDULED]: 'SCHEDULED',
  [ArrivingStatus.SKIPPED]: 'SKIPPED',
  [ArrivingStatus.ADMIN_ORDER_CANCELLED]: 'SKIPPED',
  [ArrivingStatus.CANCELLED]: 'CANCELLED',
  [ArrivingStatus.PAUSED]: 'PAUSED',
  [ArrivingStatus.RETURNING]: 'RETURNING',
  [ArrivingStatus.SUSPENDED]: 'CANCELLED',
};

function Status({ item }: Props): ReactElement {
  const {
    delivery_on: deliveryOn,
    arriving_status: arrivingStatus,
  } = item;

  const ArrivingStatusIcon = STATUS_ICONS[arrivingStatus] || QuestionIcon;
  const iconClass = `c-order__icon--${STATUS_NAMES[arrivingStatus].toLowerCase()}`;

  return (
    <>
      <div className={`c-order__icon ${iconClass}`}>
        <ArrivingStatusIcon />
      </div>

      <div className="c-order__title c-order__title--upcoming-menu">
        <div>
          <strong className="u-text u-text--uppercase">
            {`${STATUS_NAMES[arrivingStatus]}: `}
          </strong>

          <span>{weekAndMonthDay(deliveryOn)}</span>
        </div>
        <SkipLabel item={item} className="d-inline-block d-sm-none" />

        <div className="d-none d-lg-block">
          <PlanName item={item} />
        </div>
      </div>
    </>
  );
}

export default Status;
